import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { device } from 'vqp-common';
import { useDispatch } from 'react-redux';
import { Icon } from '../common';
import { logout } from '../../redux/actions/auth'
import { useHistory } from 'react-router-dom';
import { useStore } from '../../providers/store.provider';

const Wrapper = styled.div`
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    cursor: pointer;
`

const Name = styled.span`
    padding-left: 10px;
    font-size: 14px;
    color: white;

    @media ${device.mobile} {
        display: none;
    }
`

const DropdownArrow = styled.div``


export const UserDropdown = ({ name }) => {

    const dispatch = useDispatch()
    const history = useHistory()
    const storeProvider = useStore();

    const [isMultistore, setIsMultistore] = useState(storeProvider.getMultistoreState());

    useEffect(() => {
        setIsMultistore(storeProvider.getMultistoreState())
    }, [storeProvider])

    const handleLogout = async () => {
        await dispatch(logout());
        history.go({ pathname: isMultistore ? '/multilojas' : '/' })
    }

    return (
        <Wrapper onClick={handleLogout}>
            <Icon width={"24px"} height={"24px"} name="login" fill={"white"} stroke={"white"} />
            <Name>
                {name}
            </Name>
            <DropdownArrow>
                <Icon name="arrowDown" />
            </DropdownArrow>
        </Wrapper>
    )
}